import React, { useState, useRef, useMemo } from 'react'
import { makeStyles } from '@material-ui/styles'

import queryString from 'query-string'

import { withRouter } from 'react-router-dom'

import {
  TablePagination as MuiPagination, Button, ButtonGroup, Typography, AppBar, Toolbar,
  Grid, InputLabel, MenuItem, FormControl, Select, Divider, Tooltip, Paper, Collapse,
  Fab
} from '@material-ui/core'
import { FlashOn } from '@material-ui/icons'

import { useSelector, useDispatch } from 'react-redux'

import {
  setFilter, setPageChanged,
  setSelectedViolationId, setAllChecked, setPageCaptureLimit, setFromView, setStatusSnack,
  setFromLink, setPageType, setCapturesExhausted, setEndOfLink, setNeedFilter
} from '../../../redux/actions/select'

import { UnSelectAll, getTotalViolations, formatStatusClass, getViolationIndex, defaultFilter } from '../../../utils'
import { statusTypes, statusFilterDetails } from '../../../utils/variables'

import SearchBar from '../tools/SearchBar'

import StatusSnack from '../tools/StatusSnack'

// Icons for Views
import Apps from '@material-ui/icons/Apps'
import FormatListBulleted from '@material-ui/icons/FormatListBulleted'

// Icons for Modals
import Print from '@material-ui/icons/Print'
import Refresh from '@material-ui/icons/Refresh'
import SearchIcon from '@material-ui/icons/Search'
import ImportExportIcon from '@material-ui/icons/ImportExport'

import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos'

import { withStyles } from '@material-ui/core/styles'
import { isEqual } from 'lodash'

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: 'rgba(0, 0, 0, 0.54)',
    color: '#fff',
    boxShadow: theme.shadows[1],
    fontSize: 14,
    leaveTouchDelay: 10000,
    justifyContent: 'center'
  },
  arrow: {
    color: 'rgba(0,0,0,0.54)'
  }
}))(Tooltip)

const useStyles = makeStyles(() => ({
  select: {
    color: '#FFFFFF'
  },
  noFFSelect: {
    color: '#c2bfbf'
  },
  formInput: {
    color: '#FFFFFF',
    '&.Mui-focused': {
      color: '#FFFFFF'
    }
  },
  underline: {
    borderBottom: '1px solid #FFFFFF',
    '&:focus': {
      borderBottom: '2px solid #FFFFFF'
    }
  },
  paginationSelect: {
    marginRight: '10px',
    marginLeft: '5px',
    color: '#FFFFFF'
  },
  paginationToolbar: {
    paddingLeft: '10px',
    color: '#FFFFFF',
    marginTop: '10px'
  },
  paginationCaption: {
    fontWeight: 'bold',
    fontSize: '16px'
  },
  paginationActions: {
    marginLeft: 0,
    paddingRight: 0
  },
  paginationBar: {
    justifyContent: 'around',
    marginTop: '.3rem'
  },
  tableNav: {
    backgroundColor: '#4B4F58',
    opacity: '.9',
    zIndex: 900,
    minHeight: '5em',
    justifyContent: 'center',
    // width: '68%',
    margin: 'auto'
  },
  searchPaper: {
    backgroundColor: '#4B4F58',
    opacity: '.9',
    zIndex: 900,
    justifyContent: 'center',
    margin: 'auto'
  },
  sharedOnlyPaper: {
    backgroundColor: 'rgb(179, 255, 71, 0.41)',
    opacity: '.9',
    zIndex: 900,
    justifyContent: 'center',
    margin: 'auto'
  },
  limitedCapturePaper: {
    backgroundColor: 'rgb(214, 144, 0)',
    opacity: '.9',
    zIndex: 900,
    justifyContent: 'center',
    margin: 'auto'
  },
  arrowButton: {
    backgroundColor: '#C4C4C4',
    color: '#646464',
    paddingLeft: '0.5em',
    paddingRight: '0.5em',
    '&:hover': {
      backgroundColor: '#797979',
      color: '#fff'
    },
    height: '35px',
    width: '35px'
  }
}))

const TablePagination = (props) => {
  const dispatch = useDispatch()
  const classes = useStyles()

  const {
    PageCaptureLimit = 10, fromView: FromView, Filter, endOfLink, fromUrl: FromUrl
  } = useSelector(state => state.selection)

  const {
    violations: { hits, captures: Captures, limitedResults } = {}
  } = useSelector(state => state.violations)

  const DefaultView = useSelector(state => state.userSettings.general.defaultView)
  const userFilters = useSelector(state => state.filters.filters)
  const { permissions } = useSelector(state => state.auth)

  const [SelectedSort, setSelectedSort] = useState('reportedAt: desc')
  // This will set the actual index of the array that's being displayed

  const { captureAreas, fastFilterID } = useSelector(state => state.selection.Filter)

  const [currentCapture, setCurrentCapture] = useState({})
  const [fastFilters, setFastFilters] = useState([])
  const [selectedFF, setSelectedFF] = useState('')
  const [parsedProps, setParsedProps] = useState({ view: '', page: 0, captureTrgts: null })

  useMemo(() => {
    if (props.location && Boolean(props.location.search) && typeof PageCaptureLimit === 'number') {
      try {
        const searchProps = queryString.parse(props.location.search)

        if (searchProps && typeof searchProps === 'object' && Boolean(searchProps.view)) {
          // !!TO DO: This logic is duplicated numerous times in various files. Need to move to util or move this memo to a parent component of all files in which it is used.
          const captureTrgts = (() => {
            switch (searchProps.view) {
              case 'single': {
                try {
                  // capture (singular) returns a number string, with a 1 based index
                  return parseInt(searchProps.capture) || null
                } catch (err) {
                  return null
                }
              }
              case 'grid': {
                try {
                  // active captures (plural) in grid view returns an array (considered truthy even when empty so the following logic will work as expected)
                  return JSON.parse(searchProps.activeCaptures) || null
                } catch (err) {
                  return null
                }
              }
              case 'list': {
                try {
                  // active capture (singular) in list view returns a number string, with a 0 based index.
                  // Previously this used the same logic as the 'single' case. However as it was 0 based, the `parseInt(searchProps.activeCapture) || null` always returned null at the first index as 0 is falsey
                  const parsedCaptureNum = parseInt(searchProps.activeCapture)
                  if (!isNaN(parsedCaptureNum)) {
                    return parsedCaptureNum
                  } else {
                    return null
                  }
                } catch (err) {
                  return null
                }
              }
              default: return null
            }
          })()

          const page = (() => {
            if (searchProps.view === 'single' && typeof captureTrgts === 'number') { return Math.floor((captureTrgts - 1) / PageCaptureLimit) + 1 }
            return parseInt(searchProps.page) || 0
          })()

          setParsedProps({ view: searchProps.view, page, captureTrgts })
        }
      } catch (err) {
        console.log(err)
      }
    }
  }, [props.location, PageCaptureLimit])

  // find and set any fast filters in the users 'saved' filter list
  useMemo(() => {
    // if we have no local set of filters but have saved filter associated with the user
    if (Array.isArray(userFilters) && Boolean(userFilters.length)) {
      // filter out any filters in the saved list that are not fast filters
      const usersFF = userFilters.filter(x => x.isFastFilter)
      // if we had some returned, set them locally
      if (usersFF && fastFilters && !isEqual(usersFF, fastFilters)) {
        setFastFilters(usersFF)
      }
    }
  }, [fastFilters, userFilters])

  useMemo(() => {
    if (typeof Filter.fastFilterID === 'string' && selectedFF !== Filter.fastFilterID) {
      setSelectedFF(Filter.fastFilterID)
    }
  }, [Filter.fastFilterID, selectedFF])

  // if the Filter has a 'fastFilterID', set the select menu to the correct filter
  useMemo(() => {
    if (Boolean(fastFilterID) && Array.isArray(fastFilters) && Boolean(fastFilters.length)) {
      const filterExists = Boolean(fastFilters.find((fastInfo) => typeof fastInfo === 'object' && Boolean(fastInfo.filterID) && fastInfo.filterID === fastFilterID))
      if (filterExists) { setSelectedFF(fastFilterID) }
    }
  }, [fastFilterID, fastFilters])

  // calculate the index to show based on pagination
  useMemo(() => {
    if (Array.isArray(Captures) && Boolean(Captures.length) && Boolean(parsedProps.view) && parsedProps.view === 'single' && typeof PageCaptureLimit === 'number') {
      const captureIx = getViolationIndex({ captureNum: parsedProps.captureTrgts, currentView: parsedProps.view, pageLimit: PageCaptureLimit, page: parsedProps.page })

      const captureInfo = (() => {
        if (typeof captureIx === 'number') { return Captures[captureIx] }

        return {}
      })()

      setCurrentCapture({ ...captureInfo })
    }
  }, [Captures, PageCaptureLimit, parsedProps])

  const {
    onPrint, onSearch, onRefresh, snackShow, onExport, toggleFilterModal,
    SelectedStatus, setSelectedStatus, searchOpen, setSearchOpen, fromLink
  } = { ...props }

  const searchRef = useRef(null)

  // focus on the search bar when opened
  useMemo(() => {
    if (searchOpen === true) {
      searchRef.current.focus()
    }
  }, [searchOpen, searchRef])

  useMemo(() => {
    if (Array.isArray(captureAreas)) {
      if (!captureAreas.length || (captureAreas.length === 1 && captureAreas[0] === 'Flagged')) {
        setSelectedStatus(statusTypes.ALL_CAPTURES)
      } else if (captureAreas.length === 1 && captureAreas[0] === statusTypes.PROBLEM) {
        setSelectedStatus(statusTypes.PROBLEM)
      } else if (captureAreas.length === 1 && captureAreas[0] === statusTypes.UNVIEWED) {
        setSelectedStatus(statusTypes.UNVIEWED)
      } else if (captureAreas.length === 1 && captureAreas[0] === statusTypes.HOLD) {
        setSelectedStatus(statusTypes.HOLD)
      } else if (captureAreas.length === 1 && captureAreas[0] === statusTypes.RESOLVED) {
        setSelectedStatus(statusTypes.RESOLVED)
      } else if (captureAreas.length === 1 && captureAreas[0] === statusTypes.NOT_A_PROBLEM) {
        setSelectedStatus(statusTypes.NOT_A_PROBLEM)
      }
    }
  }, [captureAreas, setSelectedStatus])

  // useMemo(() => {
  //   if (parsedProps.page && parsedProps.page !== ) {
  //     dispatch(setPage(MatchPage))
  //   } else if (!MatchPage) {
  //     setCurrentPage(Page)
  //   }
  // }, [MatchPage, dispatch, Page])

  const redirect = () => {
    props.history.push({
      pathname: '/captures',
      search: parsedProps.view === 'list'
        ? '?view=list&page=1&activeCapture=0'
        : parsedProps.view === 'grid'
          ? '?view=grid&page=1&activeCaptures=[]'
          : '?view=single&capture=1'
    })
  }

  const handleSort = (e) => {
    const sort = e.target.value
    setSelectedSort(sort)
    const filter = { ...Filter, sort, refresh: true }
    dispatch(setFilter(filter))
    redirect()
  }

  const handleStatusChange = (e) => {
    const status = e.target.value
    setSelectedStatus(status)
    // if there is a fastFilterID current on the Filter, we need to reset it when anything new is changed (as it no longer matches the fast filter).
    // otherwise we can simply add to the current filter
    const baseFilter = { ...Filter, fastFilterID: '' }
    const filter = status === statusTypes.ALL_CAPTURES ? { ...baseFilter, captureAreas: [] } : { ...baseFilter, includeViolationIDs: [], captureAreas: [status], refresh: true }
    dispatch(setSelectedViolationId(0))
    dispatch(setFilter({ ...filter }))
    UnSelectAll()
    redirect()
  }

  // sets the number of captures
  const handleCaptureChange = (event) => {
    const val = event.target.value
    const valNumber = parseInt(val)
    dispatch(setPageCaptureLimit(valNumber))
    dispatch(setAllChecked(false))
    redirect()
  }

  const getDisplayText = (current, totalDisplayed, totalViolations) => {
    if (parsedProps.view === 'single') {
      if (totalViolations === 0) {
        return '0 of 0'
      } else {
        return `${(parsedProps.captureTrgts)} of ${getTotalViolations(hits)}`
      }
    } else {
      if (totalViolations === 0) {
        return '0 of 0'
      } else if ((current * totalDisplayed) > totalViolations) {
        return `${((current - 1) * totalDisplayed) + 1} - ${(totalViolations)} of ${totalViolations}`
      } else {
        return `${((current - 1) * totalDisplayed) + 1} - ${current * totalDisplayed} of ${totalViolations}`
      }
    }
  }

  // Next button used for single view
  const handleNextClicked = () => {
    if (fromLink) {
      if (typeof parsedProps.captureTrgts === 'number' && parsedProps.captureTrgts === Captures.length) {
        dispatch(setEndOfLink(true))
      }
    }

    if (typeof parsedProps.captureTrgts === 'number' && parsedProps.captureTrgts <= hits) {
      dispatch(setPageChanged(true))
      dispatch(setAllChecked(false))
      UnSelectAll()

      if (currentCapture && Boolean(currentCapture.violationID) && formatStatusClass(currentCapture.statusFlag, 'text') === 'New') {
        dispatch(setStatusSnack(true))
      } else {
        dispatch(setStatusSnack(false))
        props.history.push({
          pathname: '/captures',
          search: `?view=single&capture=${parsedProps.captureTrgts + 1}`
        })
      }
    } else {
      if (!fromLink) {
        dispatch(setNeedFilter(true))
      }
    }
  }
  // Previous button used for single view
  const handlePrevClicked = () => {
    if (typeof parsedProps.captureTrgts === 'number' && (parsedProps.captureTrgts - 1) !== 0) {
      dispatch(setAllChecked(false))
      UnSelectAll()

      if (currentCapture && Boolean(currentCapture.violationID) && formatStatusClass(currentCapture.statusFlag, 'text') === 'New') {
        dispatch(setStatusSnack(true))
        dispatch(setPageType('prev'))
      } else {
        dispatch(setStatusSnack(false))
        if (endOfLink) {
          props.history.push({
            pathname: '/captures',
            search: `?view=single&capture=${parsedProps.captureTrgts}`
          })
        } else {
          props.history.push({
            pathname: '/captures',
            search: `?view=single&capture=${parsedProps.captureTrgts - 1}`
          })
        }
        dispatch(setEndOfLink(false))
        dispatch(setCapturesExhausted(false))
      }
    }
  }

  const handleGridView = async () => {
    setSearchOpen(false)

    if (parsedProps.view !== 'single') {
      dispatch(setAllChecked(false))
      props.history.push({
        pathname: '/captures',
        search: `?view=grid&page=${parsedProps.page === 0 ? 1 : parsedProps.page}&activeCaptures=[]`
      })
    } else {
      if (currentCapture && Boolean(currentCapture.violationID) && formatStatusClass(currentCapture.statusFlag, 'text') === 'New') {
        dispatch(setStatusSnack(true))
        dispatch(setPageType('grid'))
      } else {
        dispatch(setStatusSnack(false))
        dispatch(setPageType(null))
        dispatch(setAllChecked(false))
        props.history.push({
          pathname: '/captures',
          search: `?view=grid&page=${parsedProps.page}&activeCaptures=[]`
        })
      }
    }
  }

  const handleListView = async () => {
    setSearchOpen(false)
    if (parsedProps.view !== 'single') {
      dispatch(setAllChecked(false))
      props.history.push({
        pathname: '/captures',
        search: `?view=list&page=${parsedProps.page === 0 ? 1 : parsedProps.page}&activeCapture=0`
      })
    } else {
      if (currentCapture && Boolean(currentCapture.violationID) && formatStatusClass(currentCapture.statusFlag, 'text') === 'New') {
        dispatch(setStatusSnack(true))
        dispatch(setPageType('list'))
      } else {
        dispatch(setStatusSnack(false))
        dispatch(setPageType(null))
        dispatch(setPageChanged(true))
        dispatch(setSelectedViolationId(0))
        dispatch(setAllChecked(false))
        // scrollToTop()
        props.history.push({
          pathname: '/captures',
          search: `?view=list&page=${parsedProps.page}&activeCapture=0`
        })
      }
    }
  }

  const handleExitSingle = () => {
    setSearchOpen(false)

    if (parsedProps.page > Captures.length || fromLink || (Boolean(currentCapture.violationID) && currentCapture.statusFlag !== 'U')) {
      dispatch(setFromLink(false))
      dispatch(setStatusSnack(false))
      dispatch(setPageType(null))
      // If we have been passed props from a previous capture view, then navigate back to that view.
      if (FromUrl && FromUrl.pathname && FromUrl.pathname === '/captures' && FromUrl.search && !FromUrl.search.includes('?view=single')) {
        return props.history.push({
          pathname: FromUrl.pathname,
          search: FromUrl.search
        })
      }

      if (FromView === 'list' || FromView === 'grid') {
        dispatch(setFromView(''))

        props.history.push({
          pathname: '/captures',
          search: FromView === 'list'
            ? `?view=${FromView}&page=${parsedProps.page}&activeCapture=0`
            : `?view=${FromView}&page=${parsedProps.page}&activeCaptures=[]`
        })
      } else {
        // If we have been passed props from a previous capture view, then navigate back to that view.
        if (FromUrl && FromUrl.pathname && FromUrl.pathname === '/captures' && FromUrl.search && !FromUrl.search.includes('?view=single')) {
          return props.history.push({
            pathname: FromUrl.pathname,
            search: FromUrl.search
          })
        }

        if (DefaultView === 'L') {
          props.history.push({
            pathname: '/captures',
            search: '?view=list&page=1&activeCapture=0'
          })
        } else if (DefaultView === 'G') {
          props.history.push({
            pathname: '/captures',
            search: '?view=grid&page=1&activeCaptures=[]'
          })
        }
      }
    } else {
      dispatch(setStatusSnack(true))
      dispatch(setPageType(FromView !== '' ? FromView : 'list'))
    }
  }

  const handleExitShared = () => {
    dispatch(setFromLink(false))
    dispatch(setFilter({
      ...Filter,
      violationIDs: [],
      includeViolationIDs: [],
      refresh: true
    }))
  }

  // newPage are used to determine which icon the user is clicking.
  const handleNewPage = (event, newPage) => {
    dispatch(setAllChecked(false))
    dispatch(setPageChanged(true))
    UnSelectAll()

    if ((newPage + 1) > 0) {
      switch (parsedProps.view) {
        case 'list': {
          props.history.push({
            pathname: '/captures',
            search: `?view=list&page=${newPage + 1}&activeCapture=0`
          })
          break
        }
        case 'grid': {
          props.history.push({
            pathname: '/captures',
            search: `?view=grid&page=${newPage + 1}&activeCaptures=[]`
          })
          break
        }
        default: break
      }
    }
  }

  const handleSearch = () => {
    if (currentCapture && currentCapture.statusFlag === 'U') {
      dispatch(setStatusSnack(true))
      dispatch(setPageType('search-view'))
    } else {
      setSearchOpen(!searchOpen)
    }
  }

  const handleRefresh = () => {
    if (currentCapture && currentCapture.statusFlag === 'U') {
      dispatch(setStatusSnack(true))
    } else {
      onRefresh()
    }
  }

  const nextDisabledCheck = () => {
    if (
      (
        currentCapture && Boolean(currentCapture.violationID) && formatStatusClass(currentCapture.statusFlag, 'text') === 'New'
      ) ||
      (
        Boolean(Captures.length) && typeof parsedProps.captureTrgts === 'number' && parsedProps.captureTrgts === hits && !fromLink
      ) ||
      (
        endOfLink && fromLink
      )
    ) {
      return true
    } else {
      return false
    }
  }

  // Handle changing the fastFilter select menu
  const handleFastFilterChange = (filterID) => {
    const filterInfo = fastFilters.find((fastInfo) => Boolean(filterID) && typeof fastInfo === 'object' && fastInfo.filterID === filterID)

    if (filterInfo && Boolean(filterInfo.filterID)) {
      const formattedFilter = {
        ...defaultFilter,
        fastFilterID: filterInfo.filterID || '',
        captureAreas: filterInfo.statuses || [],
        categories: filterInfo.categories || [],
        endDate: filterInfo.endDate || '',
        endtime: filterInfo.endTime || '',
        severityMax: filterInfo.severityMax || 100,
        severityMin: filterInfo.severityMin || 0,
        source: filterInfo.capture_source === 2 ? 'all' : filterInfo.capture_source,
        startDate: filterInfo.startDate || '',
        startTime: filterInfo.startTime || '',
        usernames: filterInfo.users || [],
        workstations: filterInfo.workstations || []
      }

      setSelectedFF(filterID)
      // if (typeof filterID === 'string') { setSelectedStatus() }
      dispatch(setFilter({ ...formattedFilter }))
    }

    setSelectedSort('reportedAt: desc')
    UnSelectAll()
    redirect()
  }

  return (
    <>
      <AppBar position='sticky' className={classes.tableNav} style={{ maxHeight: searchOpen && fromLink ? '11em' : '8em' }}>
        <Toolbar className={classes.paginationBar} variant='dense'>
          {parsedProps.view === 'single'
            ? (
              <>
                <Grid item xs={3}>
                  <Grid container direction='row' justify='center'>
                    <Grid item xs={12}>
                      <Button
                        className='my-3'
                        variant='contained'
                        onClick={handleExitSingle}
                        style={{ textTransform: 'none', backgroundColor: '#007BFF', color: '#FFFFFF' }}
                      >
                        Click To Exit Detail View
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={6}>
                  <Grid container direction='row' justify='center' alignItems='center'>
                    <Grid item>
                      <Tooltip
                        title={
                          !endOfLink && currentCapture && Boolean(currentCapture.violationID) && parsedProps.captureTrgts !== 1 &&
                            formatStatusClass(currentCapture.statusFlag, 'text') === 'New'
                            ? 'Capture Must Be Assigned A Status'
                            : parsedProps.captureTrgts === 1
                              ? ''
                              : 'Go to Previous Capture'
                        }
                      >
                        <span>
                          <Fab
                            disabled={parsedProps.captureTrgts === 1}
                            onClick={(e) => { e.preventDefault(); handlePrevClicked() }}
                            color='primary'
                            className={classes.arrowButton}
                          >
                            <ArrowBackIosIcon style={{ marginLeft: '.3em' }} />
                          </Fab>
                        </span>
                      </Tooltip>
                    </Grid>

                    <Grid item>
                      <Typography
                        style={{ color: 'white', fontSize: 'x-large', marginLeft: '1rem', marginRight: '1rem' }}
                      >
                        {getDisplayText(parsedProps.page, PageCaptureLimit, getTotalViolations(hits))}
                      </Typography>
                    </Grid>

                    <Grid item>
                      <Tooltip
                        title={!endOfLink && currentCapture && Boolean(currentCapture.violationID) && formatStatusClass(currentCapture.statusFlag, 'text') === 'New' ? 'Capture Must Be Assigned A Status' : 'Go to Next Capture'}
                      >
                        <span>
                          <Fab
                            disabled={!!nextDisabledCheck()}
                            onClick={(e) => { e.preventDefault(); handleNextClicked() }}
                            color='primary'
                            className={classes.arrowButton}
                          >
                            <ArrowForwardIosIcon style={{ marginLeft: '.1em' }} />
                          </Fab>
                        </span>
                      </Tooltip>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={3}>
                  <Grid container direction='row' alignItems='center' justify='flex-end'>
                    <Grid item>
                      <ButtonGroup variant='text' size='small'>
                        <Button className='text-white' title='Print' onClick={onPrint}>
                          <Print />
                        </Button>

                        <Button className='text-white' title='Export' onClick={onExport}>
                          <ImportExportIcon />
                        </Button>

                        <Button
                          className='text-white'
                          title='Search'
                          onClick={(e) => { e.preventDefault(); handleSearch() }}
                        >
                          <SearchIcon />
                        </Button>

                        <Button
                          className='text-white'
                          title='Refresh'
                          onClick={(e) => { e.preventDefault(); handleRefresh() }}
                        >
                          <Refresh />
                        </Button>
                      </ButtonGroup>
                    </Grid>
                  </Grid>
                </Grid>
              </>)
            : (
              <>
                <Grid item xs={4}>
                  <Grid container direction='row' spacing={2} justify='flex-start' alignItems='center'>
                    <Grid item xs={4}>
                      <FormControl fullWidth variant='outlined' size='small' margin='dense' focused={false}>
                        <InputLabel
                          classes={{
                            root: classes.formInput
                          }}
                        >
                          Status
                        </InputLabel>
                        {
                          captureAreas.length > 1
                            ? (
                              <>
                                <LightTooltip title='Multiple status filters applied. Remove filters to select a new one.' arrow>
                                  <Select value='Multiple' classes={{ root: classes.select }} className='pb-1' autoWidth disabled>
                                    <MenuItem value='Multiple'>Multiple</MenuItem>
                                  </Select>
                                </LightTooltip>
                              </>)
                            : (
                              <>
                                <Select
                                  value={SelectedStatus}
                                  onChange={handleStatusChange}
                                  classes={{ root: classes.select }}
                                  className='pb-1'
                                  autoWidth
                                >
                                  <MenuItem value={statusTypes.ALL_CAPTURES}>All Captures</MenuItem>
                                  {statusFilterDetails.map(statusObj => {
                                    const { statusLabel, statusPermission, statusValue } = statusObj
                                    // disable the menu option if the user does not have permissions to view
                                    const optionIsDisabled = Boolean(permissions?.length && !permissions.includes(statusPermission))
                                    return (
                                      <MenuItem
                                        key={`capture-area-${statusValue}`}
                                        value={statusObj.statusValue}
                                        disabled={optionIsDisabled}
                                      >
                                        {statusLabel}
                                      </MenuItem>
                                    )
                                  })}
                                </Select>
                              </>)
                        }
                      </FormControl>
                    </Grid>

                    <Grid item xs={4}>
                      <FormControl fullWidth variant='outlined' size='small' margin='dense' focused={false}>
                        <InputLabel classes={{ root: classes.formInput }}>
                          Sort
                        </InputLabel>
                        <Select
                          value={SelectedSort}
                          onChange={handleSort}
                          classes={{ root: classes.select }}
                          className='pb-1'
                          autoWidth
                        >
                          <MenuItem value='reportedAt: desc'>Capture Time: Newest</MenuItem>
                          <MenuItem value='reportedAt: asc'>Capture Time: Oldest</MenuItem>
                          <Divider />
                          <MenuItem value='severity: desc'>Severity: Highest</MenuItem>
                          <MenuItem value='severity: asc'>Severity: Lowest</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={4}>
                  <Grid container direction='row' justify='center' alignItems='center'>
                    <MuiPagination
                      component='div'
                      page={getTotalViolations(hits) && (parsedProps.page - 1) >= 0 ? (parsedProps.page - 1) : 0}
                      count={(getTotalViolations(hits) || 0)}
                      rowsPerPage={PageCaptureLimit || 10}
                      rowsPerPageOptions={[10, 25, 50, 100]}
                      onChangeRowsPerPage={handleCaptureChange}
                      onChangePage={handleNewPage}
                      labelRowsPerPage=''
                      classes={{
                        selectRoot: classes.paginationSelect,
                        toolbar: classes.paginationToolbar,
                        actions: classes.paginationActions,
                        caption: classes.paginationCaption
                      }}
                    />
                  </Grid>
                </Grid>

                <Grid item xs={4}>
                  <Grid container direction='row' justify='flex-end' alignItems='center'>
                    <Grid item xs={1} id='for_elevio'>
                      <span />
                    </Grid>
                    <Grid item xs='auto' style={{ width: '12px' }}>
                      <span />
                    </Grid>
                    <Grid item xs={4}>
                      <FormControl fullWidth variant='outlined' size='small' margin='dense' focused={false}>
                        <InputLabel shrink classes={{ root: classes.formInput }}>
                          <Grid container direction='row' alignItems='center'>
                            <FlashOn style={{ fontSize: 14, color: '#F5D818' }} />
                            <Typography>Fast Filter</Typography>
                          </Grid>
                        </InputLabel>
                        <Select
                          value={selectedFF}
                          onChange={(e) => handleFastFilterChange(e.target.value)}
                          classes={{ root: !selectedFF ? classes.noFFSelect : classes.select }}
                          defaultValue=''
                          displayEmpty
                          className='pb-1'
                          autoWidth
                        >
                          <MenuItem value='' disabled>{!fastFilters.length ? 'None Available' : '-None-'}</MenuItem>
                          {fastFilters.map((filter, i) => {
                            const { filterID = '', filterName = '' } = filter
                            return (
                              <MenuItem key={`fast-filter-${filterID}`} value={filterID}>{filterName}</MenuItem>
                            )
                          })}
                          <Divider />
                          <MenuItem value={null} onClick={() => { toggleFilterModal() }} style={{ fontSize: 14, color: '#3984F7', fontWeight: 600 }}>Create New Fast Filter...</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs='auto'>
                      <ButtonGroup variant='text' size='small'>
                        <Button
                          className='text-white'
                          title='List View'
                          onClick={handleListView}
                        >
                          <FormatListBulleted className='text-white' />
                        </Button>

                        <Button
                          className='text-white'
                          title='Grid View'
                          onClick={handleGridView}
                        >
                          <Apps className='text-white' />
                        </Button>

                        <Button className='text-white' title='Print' onClick={onPrint}>
                          <Print />
                        </Button>

                        <Button className='text-white' title='Export' onClick={onExport}>
                          <ImportExportIcon />
                        </Button>

                        <Button
                          className='text-white'
                          title='Search'
                          onClick={(e) => { e.preventDefault(); setSearchOpen(!searchOpen) }}
                        >
                          <SearchIcon />
                        </Button>
                        <Button className='text-white' title='Refresh' onClick={onRefresh}>
                          <Refresh />
                        </Button>
                      </ButtonGroup>
                    </Grid>
                  </Grid>
                </Grid>

                {/* <Grid item container xs={2} direction='column' style={{ marginTop: '1rem' }} className={classes.search}>
                  <Grid item container direction='row' justify='center'>
                    <SearchBar
                      onSearch={onSearch}
                    />
                  </Grid>
                </Grid> */}
              </>)}
        </Toolbar>
        <Collapse in={Boolean(searchOpen)}>
          <Paper elevation={4} className={classes.searchPaper} position='sticky'>
            <SearchBar
              onSearch={onSearch}
              setSearchOpen={setSearchOpen}
              searchRef={searchRef}
            />
          </Paper>
        </Collapse>
        <Collapse
          in={
            Boolean(Filter && Filter.violationIDs && Filter.violationIDs.length && !(Filter.statusesToAdd && Filter.statusesToAdd.length && Filter.statusesToAdd.includes('Flagged') === true))
          }
        >
          <Paper elevation={4} className={`${classes.sharedOnlyPaper} ${searchOpen ? 'mt-2' : 'mt-1'} m-1`} position='sticky'>
            <Grid container item direction='row' className='m-1' justify='center' alignItems='center'>
              <Typography variant='h6' style={{ color: '#FFFFFF', fontWeight: 'bold', marginRight: '.5em' }}>Heads up!</Typography>
              <Typography variant='body1' style={{ color: '#FFFFFF' }}>The link you entered LearnSafe by has conditioned the functionality to specific capture(s).</Typography>
              <Button
                style={{ textTransform: 'none', color: '#312f2f', fontWeight: 'bold' }}
                onClick={handleExitShared}
                id='clearShareBtn'
              >
                Click<a className='m-1' href='#clearShareButton' style={{ color: '#FFFFFF' }}>Here</a>To Have Access To All Data.
              </Button>
            </Grid>
          </Paper>
        </Collapse>
        <Collapse
          in={limitedResults}
        >
          <Paper elevation={4} className={`${classes.limitedCapturePaper} ${searchOpen ? 'mt-2' : 'mt-1'} m-1`} position='sticky'>
            <Grid container item direction='row' className='m-1' justify='center' alignItems='center'>
              <Typography variant='h6' style={{ color: '#FFFFFF', fontWeight: 'bold', marginRight: '.5em' }}>Notice:</Typography>
              <Typography variant='body1' style={{ color: '#FFFFFF' }}>Your permissions do not provide access to capture data from all statuses. Please be aware that more capture data may exist for each username.</Typography>
            </Grid>
          </Paper>
        </Collapse>
      </AppBar>
      <StatusSnack snackOpen={snackShow} />
    </>
  )
}
export default withRouter(TablePagination)
